import { Routes, Route } from "react-router-dom";

import MainLayout from "./components/MainLayout";
import Login from "./features/auth/Login";
import PersistLogin from "./features/auth/PersistLogin";
import Signup from "./features/signup/Signup";
import Verify from "./features/verify/Verify";
import ForgetPassword from "./features/reset/ForgetPassword";
import UpdatePassword from "./features/reset/UpdatePassword";

import Home from "./components/Home";

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Login />} />
          <Route path="signup" element={<Signup />} />
          <Route path="verify" element={<Verify />} />
          <Route path="forget-password" element={<ForgetPassword />} />
          <Route path="update-password" element={<UpdatePassword />} />
          <Route element={<PersistLogin />}>
            <Route path="home" element={<Home />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
};

export default App;
